import AppDashboard from '../AppDashboard';
import ProcessClaimsScreen from '../../components/admin/ProcessClaimsScreen';

const AdminProcessClaimsPage = props => {
  return (
    <AppDashboard>
      <ProcessClaimsScreen />
    </AppDashboard>
  );
};

export default AdminProcessClaimsPage;